import React, { useRef, useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Box } from '@mui/material'
import AdminNavbar from '../components/Navbars/AdminNavbar'
import AdminFooter from '../components/Footers/AdminFooter'

import routes from '../routes'

function Restaurant(props) {
  var divRef = useRef(null)
  useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
    divRef.current.scrollTop = 0
  }, [])

  const getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === '/restaurant') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        )
      } else {
        return null
      }
    })
  }
  const getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props.location.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name
      }
    }
    return 'Brand'
  }
  return (
    <>
      <div
        ref={divRef}
        style={{
          backgroundColor: '#F6F7F9',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column'
        }}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />
        <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, pb: 3, flexGrow: 1 }}>
          <Switch>{getRoutes(routes)}</Switch>
        </Box>
        <AdminFooter />
      </div>
    </>
  )
}

export default Restaurant
